export const FETCH_AUTH_REQUEST = "FETCH_AUTH_REQUEST";
export const FETCH_AUTH_SUCCESS = "FETCH_AUTH_SUCCESS";
export const FETCH_AUTH_FAILURE = "FETCH_AUTH_FAILURE";
export const LOGOUT_AUTH = "LOGOUT_AUTH";
export const FETCH_SHORT_PIN_REQUEST = "FETCH_SHORT_PIN_REQUEST";
export const FETCH_SHORT_PIN_SUCCESS = "FETCH_SHORT_PIN_SUCCESS";
export const FETCH_SHORT_PIN_FAILURE = "FETCH_SHORT_PIN_FAILURE";
export const FETCH_AUTH_PIN_REQUEST = "FETCH_AUTH_PIN_REQUEST";
export const FETCH_AUTH_PIN_SUCCESS = "FETCH_AUTH_PIN_SUCCESS";
export const FETCH_AUTH_PIN_FAILURE = "FETCH_AUTH_PIN_FAILURE";
